import { useReleases } from "@/routes/simulator/context/release";
import { useUpdateSimulator } from "@/api/useRelease";
import { OptionalFieldGroup } from "./FieldGroup";
import { useFlag } from "@/v2/components/feature-flag/FeatureFlagContext";

export function UpdateSimulatorReclassifyTopicOnSubsequentAnswers() {
  const isEnabled = useFlag("reclassifyTopicOnSubsequentAnswers", false);
  const { simulator, refetchSimulators } = useReleases();

  const { mutateAsync: updateSimulator } = useUpdateSimulator({
    simulatorId: simulator?.id ?? 0,
  });

  if (!isEnabled) {
    return null;
  }

  return (
    <OptionalFieldGroup
      label={"Reclassify Topic on Subsequent Answers"}
      description={
        "Enable automatic topic reclassification for subsequent answers in conversations"
      }
      enabled={simulator?.reclassifyTopicOnSubsequentAnswers ?? false}
      toggleEnabled={async (nextValue) => {
        if (simulator?.id) {
          await updateSimulator({
            name: simulator.name,
            reclassifyTopicOnSubsequentAnswers: nextValue,
          });
          await refetchSimulators();
        }
      }}
    />
  );
}
